import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export function deleteAuthFederationKeyRequestConfig(kid: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'DELETE',
    endpoint: `auth-federation/admin/keys/${kid}`,
    serverWideRequest: false
  };
}

export function callDeleteAuthFederationKeyRequest(kid: string): Promise<void> {
  return makeJsonRestApiRequest<null, void>({
    config: deleteAuthFederationKeyRequestConfig(kid),
    request: null
  });
}
